// Editable assumptions for a domestic approximation, never invoice extraction.
export const QUICK_ASSUMPTIONS = {
    power: 4.6, powerP1: 0.08, powerP2: 0.04, rental: 0.81,
    ie: 5.11269632, vat: 21, socialAnnual: 6.979247,
};
export const QUICK_ESTIMATE_NOTICE = 'Simulación orientativa con datos aproximados. El reparto del consumo, la potencia y otros conceptos se han estimado; revisa los supuestos antes de proponer una oferta.';

const rounded = (value, digits = 6) => Number(value.toFixed(digits));
const validNumber = (value, minimum, maximum = Infinity) => {
    if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') return false;
    const number = Number(value);
    return Number.isFinite(number) && number >= minimum && number <= maximum;
};

export function quickSimulationInput({ consumption, total, socialFunding, assumptions = QUICK_ASSUMPTIONS }, draft = {}, now = new Date()) {
    if (draft.tarifa_atr !== '2.0TD' || !['PENINSULA', 'BALEARES'].includes(draft.geo_zone)) {
        throw new Error('La simulación rápida está disponible para 2.0TD en Península y Baleares. Utiliza los datos detallados para este suministro.');
    }
    if (!validNumber(consumption, 0.001) || !validNumber(total, 0.01)) throw new Error('Indica un consumo mensual y un importe mayores que cero.');
    if (typeof socialFunding !== 'boolean') throw new Error('Confirma si se cobra la financiación del bono social.');
    const a = Object.fromEntries(Object.entries(assumptions).map(([key, value]) => [key, Number(value)]));
    if (!Object.keys(QUICK_ASSUMPTIONS).every(key => validNumber(assumptions[key], key === 'power' ? 0.001 : 0,
        ['ie', 'vat'].includes(key) ? 100 : key === 'power' ? 15 : Infinity))) throw new Error('Revisa los supuestos: importes positivos, potencia hasta 15 kW y porcentajes entre 0 y 100.');
    const days = 30;
    const social = socialFunding ? rounded(a.socialAnnual * days / 365, 2) : 0;
    const power = a.power * (a.powerP1 + a.powerP2) * days;
    // Invert the same tax bases used by the comparator, keeping the given total.
    const energy = (Number(total) / (1 + a.vat / 100) - a.rental) / (1 + a.ie / 100) - power - social;
    if (!Number.isFinite(energy) || energy <= 0) throw new Error('El importe no cubre los costes fijos estimados. Revisa el total, la potencia o los supuestos.');
    const end = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    const start = new Date(end.getTime() - (days - 1) * 86400000);
    const kwh = Number(consumption), price = rounded(energy / kwh);
    if (!Number.isFinite(price) || price <= 0) throw new Error('Revisa la relación entre el consumo y el importe mensual.');
    const p1 = rounded(kwh * 0.25), p2 = rounded(kwh * 0.25);
    return {
        ...draft, fecha_inicio: start.toISOString().slice(0, 10), fecha_fin: end.toISOString().slice(0, 10), dias_facturados: days,
        consumo_total_kwh: undefined, reparto_consumo_pct: undefined,
        consumos_kwh: { P1: p1, P2: p2, P3: rounded(kwh - p1 - p2) },
        potencias_kw: { P1: a.power, P2: a.power },
        precios_energia_eur_kwh: { P1: price, P2: price, P3: price },
        precios_potencia: { P1: a.powerP1, P2: a.powerP2 }, unidad_precio_potencia: 'eur_kw_dia',
        ie_pct: a.ie, iva_pct: a.vat, alquiler_eur: a.rental, bono_social_eur: social,
        total_factura_eur: Number(total), excedentes_kwh: 0, precio_excedentes_eur_kwh: 0, total_descuentos_eur: 0,
        _esave_estimate: { kind: 'monthly_quick_v1', consumption: kwh, total: Number(total), socialFunding,
            assumptions: a, days, profile: { P1: 25, P2: 25, P3: 50 }, created_at: now.toISOString() },
    };
}
